import { render, staticRenderFns } from "./InputWidget.vue?vue&type=template&id=64078a73&"
import script from "./InputWidget.vue?vue&type=script&lang=js&"
export * from "./InputWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports